// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l-YY","colBig":"styles_colBig__AVrnG","colSmall":"styles_colSmall__1QWnl"};